import { forwardRef, type ButtonHTMLAttributes } from 'react';
import Icon from 'Components/Icon';

interface ActivityIconButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  num?: number;
  hasViews?: boolean;
  size?: 'sm' | 'lg';
}

const ActivityIconButton = forwardRef<
  HTMLButtonElement,
  ActivityIconButtonProps
>(({ num, hasViews, size = 'sm', ...props }, ref) => {
  const isLg = size === 'lg';

  return (
    <button
      ref={ref}
      className={`tw tw:border-none tw:bg-transparent tw:cursor-pointer tw:p-0 tw:relative tw:top-[2px] tw:rounded tw:transition-colors tw:hover:bg-gray-100 ${hasViews ? 'tw:text-[var(--primary-color)] tw:hover:opacity-80' : 'tw:text-gray-400 tw:hover:text-gray-500'}`}
      {...props}
    >
      <span
        className={`tw:relative tw:flex tw:items-center tw:justify-center ${isLg ? 'tw:w-8 tw:h-8' : 'tw:w-6 tw:h-6'}`}
      >
        <Icon
          name="groups"
          className={isLg ? 'tw:text-[32px]' : 'tw:text-[24px]'}
        />
        {!!num && (
          <span className="tw:absolute tw:-top-0.5 tw:-right-1 tw:bg-bid tw:text-white tw:text-[0.6rem] tw:leading-none tw:rounded-full tw:min-w-[16px] tw:h-[16px] tw:flex tw:items-center tw:justify-center tw:px-0.5">
            {num}
          </span>
        )}
      </span>
    </button>
  );
});

ActivityIconButton.displayName = 'ActivityIconButton';

export default ActivityIconButton;
